<nav class="lib-nav" *ngIf="!accepted">
  <lib-icon name="cookie"></lib-icon>
  <h6 class="lib-legend">We use cookies to improve your experience. By using our website, you agree to our <a href="https://www.proportunity.com/cookie-policy" target="_blank">cookies policy</a>.</h6>
  <span class="lib-spacer"></span>
  <button class="lib-button" (click)="accept($event)">
    <lib-icon name="close"></lib-icon>
  </button>
</nav>
